// English strings (source language): legendary challenges (screen, HUD banner, end screen).

const en = {
  title: 'Legendary challenges',
  intro:
    'Monumental goals on their own road. A challenge adds up your rides: the clock starts with your first ride and keeps running through your breaks. Each ride is saved as you go, so a crash costs minutes, not the day.',
  target: { climb: (m: string) => `${m} m of climbing`, time: (h: string) => `${h} h of riding`, distance: (km: string) => `${km} km` },
  window: (h: number) => `${h} h on the clock`,
  value: { climb: (m: string) => `${m} m`, time: (dur: string) => dur, distance: (km: string) => `${km} km` },
  progress: (done: string, target: string) => `${done} of ${target}`,
  timeLeft: (dur: string) => `${dur} left on the clock`,
  rides: (n: number) => `${n} ride${n === 1 ? '' : 's'} in this attempt`,
  notStarted: 'Not started yet: your first ride starts the clock.',
  expired: 'The last attempt ran out of time: your next ride starts a new one.',
  completions: (n: number) => `Completed ${n} time${n === 1 ? '' : 's'}`,
  best: (dur: string) => `best: ${dur}`,
  xp: (n: number) => `+${n} XP per completion`,
  start: 'Start the challenge',
  resume: 'Continue the attempt',
  sessionCap: 'A ride ends by itself after almost 24 hours or when the goal is reached: save it, then continue.',
  /** HUD banner during a challenge ride. */
  hud: (done: string, target: string, pct: number) => `${done} / ${target} · ${pct}%`,
  /** End screen. */
  doneTitle: (name: string) => `🏆 ${name}: challenge completed!`,
  doneHelp: (dur: string) => `Achieved in ${dur} on the clock. A legend.`,
  partTitle: (name: string) => `${name}: attempt in progress`,
  partHelp: (left: string, clock: string) => `Still ${left} to go, ${clock} left on the clock.`,
  notCounted: 'Ride too short to save: it does not count towards the challenge.',
};
export default en;
